module.exports = __webpack_public_path__ + "img/img_folleto.cb8aa722.png";